export default {
  ['DIALOG_CREATE'](state, payload) {
    state.items = [...state.items, payload];
  },
  ['DIALOG_DESTROY'](state, payload) {
    state.items = state.items.filter(dialog => dialog.id !== payload);
  },
  ['DIALOG_UPDATE'](state, payload) {
    state.items = state.items.map(dialog => (dialog.id === payload.id ? Object.assign({}, dialog, payload) : dialog));
  },
}
